/* @flow */
import MessageDelivery from 'entities/MessageDelivery';
import MessageDeliverySummary from 'entities/MessageDeliverySummary';

import type ChatMessage from 'entities/ChatMessage';

export default class ChatMessageDelivery extends MessageDelivery {
  static createFromChatMessage(chatMessage: ChatMessage) {
    return new ChatMessageDelivery({
      message_type: 'chat',
      message_uuid: chatMessage.id,
      read_summary: new MessageDeliverySummary(chatMessage.getReadSummary()),
      stream_uuid: chatMessage.getChatId(),
    });
  }
}
